import React from 'react';
import { string, bool, func } from 'prop-types';
import { useTranslation } from 'react-i18next';

const Input = ({
  autoComplete,
  parentClass,
  label,
  type,
  name,
  placeholder,
  value,
  disabled,
  handleInputBlur,
  handleInputChange,
  error,
  autoFocus,
  accountInfoPage,
  ariaRequired = true
}) => {
  const { t } = useTranslation();
  return (
    <div className={`${parentClass} form-group`}>
      {accountInfoPage ? (
        <h3 id={`${name}-field`} htmlFor={name}>
          {label || ''}
        </h3>
      ) : (
        <label id={`${name}-field`} htmlFor={name}>
          {label || ''}
        </label>
      )}

      <input
        type={type || 'text'}
        name={name}
        placeholder={placeholder || ''}
        value={value}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        disabled={disabled}
        className={
          error ? 'invalid dialogComponent' : 'noError dialogComponent'
        }
        autoComplete={name === 'email' ? true : 'off'}
        autoFocus={autoFocus}
        aria-labelledby={`${name}-field`}
        aria-required={ariaRequired}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        autoComplete={autoComplete}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={`${name}error`}
      />
      <span id={`${name}error`} className="label-error" role="alert">
        {t(error)}
      </span>
    </div>
  );
};

Input.propTypes = {
  parentClass: string,
  label: string,
  type: string,
  name: string,
  placeholder: string,
  value: string,
  disabled: bool,
  handleInputBlur: func,
  handleInputChange: func,
  error: string,
  autoFocus: bool,
  ariaRequired: bool,
  autoComplete: string,
  accountInfoPage: bool
};

Input.defaultProps = {
  parentClass: '',
  label: '',
  type: '',
  name: '',
  placeholder: '',
  value: '',
  disabled: false,
  handleInputBlur: () => {},
  handleInputChange: () => {},
  error: '',
  autoFocus: false,
  ariaRequired: true,
  autoComplete: '',
  accountInfoPage: false
};
export default Input;
